__webpack_require__.p = "/shared-mailbox-archive-tab/referrals-hub/";